import { createFileRoute } from '@tanstack/react-router'
import { type } from 'arktype'

import { ExperimentsPage } from '#/modules/ai/back-office/experiments-page/experiments-page.tsx'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

const searchSchema = type({ workflowId: 'string' })

export const Route = createFileRoute('/bo/ai/experiments/$agentId')({
  beforeLoad: ({ context }) => requirePermissions(context, ['aiAnalysis.evaluation.run']),
  validateSearch: searchSchema,
  component: function Component() {
    const { agentId } = Route.useParams()
    const { workflowId } = Route.useSearch()
    return <ExperimentsPage workflowId={workflowId} agentId={agentId} />
  },
})
